export default {

  // COMMON
  BG_COLOR: '#f3f3f3',
  MAIN_COLOR: '#000000',
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#1a7da1',
  SECONDARY_COLOR: '#96C537', // acl dark grey
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
